import ApplicationReducer from "@store/slices/application";
import authorizationReducer from "@store/slices/authorization";
import notificationsReducer from "@store/slices/notifications";
import { configureStore } from "@reduxjs/toolkit";

const store = configureStore({
    reducer: {
        application: ApplicationReducer,
        notifications: notificationsReducer,
        authorization: authorizationReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

export type TRootState = ReturnType<typeof store.getState>;
export type TAppDispatch = typeof store.dispatch;
export default store;
